import React from 'react';

const PatientResources = () => {
  return null;
};

export default PatientResources;